import { render, staticRenderFns } from "./AppIconCoachMarkPc.vue?vue&type=template&id=e05c2764"
import script from "./AppIconCoachMarkPc.vue?vue&type=script&lang=js"
export * from "./AppIconCoachMarkPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports